import React from 'react';




function OrderTableHead(){
  
                    return (
                        <tr>
                                <th>id</th>
                                <th>Cliente</th>
                                <th>Fecha</th>
                                <th>Estado</th>
                                <th>Total</th>
                                <th>Metodo de Pago</th>
                                <th>Detalle</th>
                        </tr>
                    )
    }
    
        

export default OrderTableHead;